import { AttributeGroup } from '@teko/ecommerce';

export const groupAttributes = (attributes: AttributeGroup[]) => {
  const parentAttributes = (attributes.filter((att) => att.parentId === 0) ||
    []) as AttributeGroup[];

  const mapAtttributes = new Map<string | number, AttributeGroup[]>(
    parentAttributes.map((att) => [att.id, []]),
  );

  attributes.forEach((att) => {
    if (att.parentId === 0 || !att.value) return;
    const children = mapAtttributes.get(att.parentId);
    if (children) {
      children.push(att);
      mapAtttributes.set(att.parentId, children);
    }
  });

  let displayAttributes: AttributeGroup[] = [];
  parentAttributes.forEach((att) => {
    const children = mapAtttributes.get(att.id) || [];
    if (!!children.length) {
      displayAttributes.push(att);
      displayAttributes = [...displayAttributes, ...children];
    }
  });
  return displayAttributes;
};

export const isShowRetailPrice = (
  supplierRetailPrice: string | number,
  latestPrice: string | number,
) => {
  let newSupplierRetailPrice = supplierRetailPrice;
  let newLatestPrice = latestPrice;

  if (typeof supplierRetailPrice === 'string') {
    newSupplierRetailPrice = supplierRetailPrice.replace(/[₫đ.]/g, '');
  }

  if (typeof latestPrice === 'string') {
    newLatestPrice = latestPrice.replace(/[₫đ.]/g, '');
  }

  return Number(newSupplierRetailPrice) > Number(newLatestPrice);
};
